import TestController from '../TestController';
import IScheduledTaskState from './IScheduledTaskState';
import ScheduledTaskManager from './ScheduledTaskManager';

abstract class AbstractScheduledTaskState implements IScheduledTaskState {
  protected readonly scheduledTaskManager: ScheduledTaskManager;
  protected readonly testController: TestController;

  constructor(scheduledTaskManager: ScheduledTaskManager, testController: TestController) {
    this.scheduledTaskManager = scheduledTaskManager;
    this.testController = testController;
  }

  handleEvent() {
    throw new Error('Method not implemented.');
  }

  isReviewScreen(): boolean {
    if (this.testController.navigationController && this.testController.navigationController.navigationContext) {
      return this.testController.navigationController.navigationContext.isReviewScreen();
    }
    return false;
  }
}

export default AbstractScheduledTaskState;
